import { Type } from '@angular/core';
import { DataTypeStr } from '@common-modules/shared/core/data-type-str';
import { BaseDashboardSettingsComponent } from './core/base-dashboard-settings.component';
import { DashboardCategoryChartSettingsComponent } from './dashboard-category-chart-settings/dashboard-category-chart-settings.component';
import { DashboardChartSettingsComponent } from './dashboard-chart-settings/dashboard-chart-settings.component';
import { DashboardGridSettingsComponent } from './dashboard-grid-settings/dashboard-grid-settings.component';
import { DashboardTextSettingsComponent } from './dashboard-text-settings/dashboard-text-settings.component';
import { DashboardWidgetTypes } from './models/dashboard-widget-types';

export const ctDashboardSettingsComponentByType = new Map<
  DashboardWidgetTypes,
  Type<BaseDashboardSettingsComponent>
>([
  [DashboardWidgetTypes.AttributeChart, DashboardChartSettingsComponent],
  [DashboardWidgetTypes.AttributeCategory, DashboardCategoryChartSettingsComponent],
  [DashboardWidgetTypes.Grid, DashboardGridSettingsComponent],
  [DashboardWidgetTypes.Text, DashboardTextSettingsComponent],
]);

export const ctAllowedDataTypesByWidget = new Map<DashboardWidgetTypes, string[]>([
  [DashboardWidgetTypes.AttributeChart, [DataTypeStr.Int, DataTypeStr.Double]],
  [DashboardWidgetTypes.AttributeCategory, [DataTypeStr.String]],
  [DashboardWidgetTypes.Grid, [DataTypeStr.Int, DataTypeStr.Double, DataTypeStr.String]],
  [DashboardWidgetTypes.Kpi, [DataTypeStr.Int, DataTypeStr.Double, DataTypeStr.String]],
  [DashboardWidgetTypes.Text, [DataTypeStr.String]],
]);
